<template>
  <sc-page-base
    :title="title"
    :loading="loading">
    <sc-tabs
      v-model="activeTab"
      type="is-boxed has-form"
      class="page-pre-invoice-detail__tabs"
      :animated="false"
      @input="setRoute"
      destroy-on-hide>
      <sc-tab-item label="CTEs">
        <sc-pre-invoice-detail-ctes @back="back" />
      </sc-tab-item>

      <sc-tab-item label="Valores">
        <sc-pre-invoice-detail-values @back="back" />
      </sc-tab-item>

      <sc-tab-item label="Histórico">
        <sc-pre-invoice-detail-history @back="back" />
      </sc-tab-item>
    </sc-tabs>
  </sc-page-base>
</template>

<script>
import {
  ScButton,
  ScPageBase,
  ScTabs,
  ScTabItem,
} from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';
import ScPreInvoiceDetailCtes from './components/sc-pre-invoice-detail-ctes/ScPreInvoiceDetailCtes';
import ScPreInvoiceDetailValues from './components/sc-pre-invoice-detail-values/ScPreInvoiceDetailValues';
import ScPreInvoiceDetailHistory from './components/sc-pre-invoice-detail-history/ScPreInvoiceDetailHistory';

const {
  mapState,
} = createNamespacedHelpers('recon/preInvoiceDetail');
export default {
  name: 'page-pre-invoice-detail',
  data() {
    return {
      title: 'Detalhe da Fatura',
      activeTab: 0,
      actions: ['cte', 'values', 'history'],
    };
  },
  computed: {
    ...mapState([
      'loading',
    ]),
  },
  methods: {
    setRoute(tabIndex) {
      this.$router.push({
        name: 'pre-invoice-detail',
        query: {
          ...this.$route.query || {},
          ...{ action: this.actions[tabIndex] || this.actions[0] },
        },
      });
      this.activeTab = tabIndex;
    },
    back() {
      const { id } = this.$route.params || {};

      this.$router.push({
        name: 'pre-invoice-generation',
        params: {
          id,
        },
      });
    },
  },
  beforeMount() {
    const { action } = this.$route.query || {};

    this.activeTab = this.actions.indexOf(action) !== -1 ? this.actions.indexOf(action) : 0;

    if (!action) {
      this.setRoute(0);
    }
  },
  components: {
    ScButton,
    ScPageBase,
    ScTabs,
    ScTabItem,
    ScPreInvoiceDetailCtes,
    ScPreInvoiceDetailValues,
    ScPreInvoiceDetailHistory,
  },
};
</script>
<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

.page-pre-invoice-detail {
  &__panel {
    &__block {
      &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &.vertical {
        flex-direction: column;
      }
    }
  }

  &__tabs {
    .has-form , .tab-content {
      overflow: visible !important;
    }
  }

  &__cols {
    flex: 1;

    @media (max-width: 768px) {
      display: flex;
    }

    .column {
      word-break: break-all;
    }
  }

  &__box-footer {
    background-color: whitesmoke;
    border-top: 1px solid #e7e7e7;
    margin: 1.25rem -1.25rem -1.25rem -1.25rem;
    padding: 0.5rem;
    border-radius: 0 0 5px 5px;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/PagePreInvoiceDetail.vue